/* =========================================================
   BAHARI AQUA - PRODUCT VARIANT LOGIC V4 FIXED
   Para: assets/bahari-template-product.js
   Compatible con bahari-product-template.fixed.liquid
   ========================================================= */

(function () {
  function initBahariProduct(section) {
    if (!section || section.dataset.bahariProductInitialized === 'true') return;

    const productJson = section.querySelector('[data-product-json]');
    if (!productJson) return;

    let product;

    try {
      product = JSON.parse(productJson.textContent);
    } catch (error) {
      console.warn('[Bahari product] No se pudo leer el JSON del producto.', error);
      return;
    }

    section.dataset.bahariProductInitialized = 'true';

    const productForm = section.querySelector('[data-product-form]');
    const variantInput = section.querySelector('[data-variant-id-input]');
    const priceElements = section.querySelectorAll('[data-product-price]');
    const comparePriceElements = section.querySelectorAll('[data-product-compare-price]');
    const addToCartButtons = section.querySelectorAll('.bahari-product__add-to-cart');

    const slides = Array.from(section.querySelectorAll('[data-slide]'));
    const prevButton = section.querySelector('[data-gallery-prev]');
    const nextButton = section.querySelector('[data-gallery-next]');
    const gallery = section.querySelector('[data-bahari-gallery]');

    let currentSlideIndex = slides.findIndex((slide) => {
      return slide.classList.contains('is-active');
    });

    if (currentSlideIndex < 0) currentSlideIndex = 0;

    function cssEscape(value) {
      if (window.CSS && typeof window.CSS.escape === 'function') {
        return CSS.escape(String(value));
      }

      return String(value).replace(/"/g, '\\"');
    }

    function formatMoney(cents) {
      const value = Number(cents || 0);

      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        const format =
          window.theme?.moneyFormat ||
          window.moneyFormat ||
          '${{amount_no_decimals}}';

        return window.Shopify.formatMoney(value, format);
      }

      return new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(value / 100);
    }

    function normalizeImageUrl(url) {
      if (!url) return '';

      return String(url)
        .replace(/^https?:/, '')
        .split('?')[0]
        .replace(/_(\d+x\d+|small|medium|large|grande|compact|master)\./, '.');
    }

    function getOptionInputs() {
      return Array.from(section.querySelectorAll('[data-option-input]'));
    }

    function getColorInputs() {
      return Array.from(section.querySelectorAll('[data-option-color]'));
    }

    function getSizeInputs() {
      return Array.from(section.querySelectorAll('[data-option-size]'));
    }

    function getGenericInputs() {
      return Array.from(section.querySelectorAll('[data-option-generic]'));
    }

    function getInputOptionIndex(input) {
      return Number(input.dataset.optionIndex);
    }

    function getInputsByOptionIndex(optionIndex) {
      return getOptionInputs().filter((input) => {
        return getInputOptionIndex(input) === Number(optionIndex);
      });
    }

    function getSelectedOptions() {
      const selectedOptions = [];

      product.options.forEach(function (_optionName, index) {
        const checkedInput = section.querySelector(
          '[data-option-input][data-option-index="' + index + '"]:checked'
        );

        selectedOptions[index] = checkedInput ? checkedInput.value : null;
      });

      return selectedOptions;
    }

    function getVariantOptions(variant) {
      if (!variant) return [];

      if (Array.isArray(variant.options)) {
        return variant.options;
      }

      return product.options.map(function (_optionName, index) {
        return variant['option' + (index + 1)];
      });
    }

    function variantMatchesOptions(variant, options, ignoreIndex) {
      const variantOptions = getVariantOptions(variant);

      return options.every(function (value, index) {
        if (index === ignoreIndex) return true;
        if (value === null || value === undefined || value === '') return true;

        return variantOptions[index] === value;
      });
    }

    function findVariantByOptions(options) {
      return product.variants.find(function (variant) {
        const variantOptions = getVariantOptions(variant);

        return variantOptions.every(function (value, index) {
          return value === options[index];
        });
      });
    }

    function findFirstAvailableVariant() {
      return product.variants.find(function (variant) {
        return variant.available;
      }) || product.variants[0];
    }

    function findFirstVariantMatchingOption(optionIndex, value, availableOnly) {
      return product.variants.find(function (variant) {
        const variantOptions = getVariantOptions(variant);

        if (variantOptions[optionIndex] !== value) return false;
        if (availableOnly && !variant.available) return false;

        return true;
      });
    }

    function findFirstAvailableVariantForColor(colorIndex, colorValue) {
      return product.variants.find(function (variant) {
        const variantOptions = getVariantOptions(variant);

        return variant.available && variantOptions[colorIndex] === colorValue;
      });
    }

    function findFirstVariantForColor(colorIndex, colorValue) {
      return product.variants.find(function (variant) {
        const variantOptions = getVariantOptions(variant);

        return variantOptions[colorIndex] === colorValue;
      });
    }

    function getColorOptionIndex() {
      const colorInput = section.querySelector('[data-option-color]');
      if (!colorInput) return -1;

      return getInputOptionIndex(colorInput);
    }

    function getSizeOptionIndex() {
      const sizeInput = section.querySelector('[data-option-size]');
      if (!sizeInput) return -1;

      return getInputOptionIndex(sizeInput);
    }

    function getSelectedColorValue() {
      const colorInput = section.querySelector('[data-option-color]:checked');
      return colorInput ? colorInput.value : null;
    }

    function syncInputsToVariant(variant) {
      if (!variant) return;

      const variantOptions = getVariantOptions(variant);

      variantOptions.forEach(function (value, index) {
        const input = section.querySelector(
          '[data-option-input][data-option-index="' +
            index +
            '"][value="' +
            cssEscape(value) +
            '"]'
        );

        if (input) {
          input.checked = true;
        }
      });
    }

    function setSelectedClasses() {
      getOptionInputs().forEach(function (input) {
        const label = section.querySelector('label[for="' + cssEscape(input.id) + '"]');

        if (!label) return;

        label.classList.toggle('is-selected', input.checked);
      });
    }

    function findBestVariant(changedInput) {
      const selectedOptions = getSelectedOptions();
      const exactVariant = findVariantByOptions(selectedOptions);

      if (exactVariant) {
        return exactVariant;
      }

      if (!changedInput) {
        return findFirstAvailableVariant();
      }

      const changedIndex = getInputOptionIndex(changedInput);

      if (changedInput.hasAttribute('data-option-color')) {
        const availableByColor = findFirstAvailableVariantForColor(
          changedIndex,
          changedInput.value
        );

        if (availableByColor) return availableByColor;

        const anyByColor = findFirstVariantForColor(changedIndex, changedInput.value);
        if (anyByColor) return anyByColor;
      }

      if (changedInput.hasAttribute('data-option-size')) {
        const availableBySize = findFirstVariantMatchingOption(
          changedIndex,
          changedInput.value,
          true
        );

        if (availableBySize) return availableBySize;

        const anyBySize = findFirstVariantMatchingOption(
          changedIndex,
          changedInput.value,
          false
        );

        if (anyBySize) return anyBySize;
      }

      return findFirstAvailableVariant();
    }

    function variantExistsForCandidate(optionIndex, optionValue, availableOnly) {
      const selectedOptions = getSelectedOptions();
      const candidateOptions = selectedOptions.slice();

      candidateOptions[optionIndex] = optionValue;

      return product.variants.some(function (variant) {
        if (availableOnly && !variant.available) return false;

        const variantOptions = getVariantOptions(variant);

        return variantOptions.every(function (value, index) {
          if (candidateOptions[index] === null || candidateOptions[index] === undefined) {
            return true;
          }

          return value === candidateOptions[index];
        });
      });
    }

    function updateOptionAvailability() {
      const selectedOptions = getSelectedOptions();
      const colorIndex = getColorOptionIndex();
      const selectedColor = getSelectedColorValue();

      getOptionInputs().forEach(function (input) {
        const optionIndex = getInputOptionIndex(input);
        const label = section.querySelector('label[for="' + cssEscape(input.id) + '"]');

        const isColor = input.hasAttribute('data-option-color');
        const isSize = input.hasAttribute('data-option-size');

        if (isColor) {
          const hasAnyAvailableVariantForColor = product.variants.some(function (variant) {
            const variantOptions = getVariantOptions(variant);

            return variant.available && variantOptions[optionIndex] === input.value;
          });

          input.disabled = false;

          if (label) {
            label.classList.remove('is-disabled');
            label.classList.toggle('is-soldout', !hasAnyAvailableVariantForColor);
          }

          return;
        }

        let hasAvailableVariant = false;

        if (isSize && colorIndex >= 0 && selectedColor) {
          hasAvailableVariant = product.variants.some(function (variant) {
            const variantOptions = getVariantOptions(variant);

            return (
              variant.available &&
              variantOptions[colorIndex] === selectedColor &&
              variantOptions[optionIndex] === input.value
            );
          });
        } else {
          const candidateOptions = selectedOptions.slice();
          candidateOptions[optionIndex] = input.value;

          hasAvailableVariant = product.variants.some(function (variant) {
            if (!variant.available) return false;

            const variantOptions = getVariantOptions(variant);

            return variantOptions.every(function (value, index) {
              if (candidateOptions[index] === null || candidateOptions[index] === undefined) {
                return true;
              }

              return value === candidateOptions[index];
            });
          });
        }

        input.disabled = !hasAvailableVariant;

        if (label) {
          label.classList.toggle('is-disabled', !hasAvailableVariant);
        }
      });
    }

    function updateSelectedTexts() {
      const selectedColorLabel = section.querySelector('[data-selected-color]');
      const selectedColorInput = section.querySelector('[data-option-color]:checked');

      if (selectedColorLabel && selectedColorInput) {
        selectedColorLabel.textContent = selectedColorInput.value;
      }

      section.querySelectorAll('[data-selected-option-value]').forEach(function (label) {
        const position = Number(label.dataset.selectedOptionValue);
        const index = position - 1;

        const selectedInput = section.querySelector(
          '[data-option-input][data-option-index="' + index + '"]:checked'
        );

        if (selectedInput) {
          label.textContent = selectedInput.value;
        }
      });
    }

    function updatePrice(variant) {
      if (!variant) return;

      priceElements.forEach(function (priceElement) {
        priceElement.innerHTML = formatMoney(variant.price);
      });

      comparePriceElements.forEach(function (compareElement) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareElement.innerHTML = formatMoney(variant.compare_at_price);
          compareElement.removeAttribute('hidden');
        } else {
          compareElement.innerHTML = '';
          compareElement.setAttribute('hidden', 'hidden');
        }
      });
    }

    function setButtonState(variant) {
      addToCartButtons.forEach(function (button) {
        if (!button) return;

        const availableText = button.dataset.availableText || 'Añadir al carrito';
        const unavailableText = button.dataset.unavailableText || 'Agotado';

        if (variant && variant.available) {
          button.removeAttribute('disabled');
          button.textContent = availableText;
        } else {
          button.setAttribute('disabled', 'disabled');
          button.textContent = unavailableText;
        }
      });

      const paymentButtons = section.querySelectorAll('.shopify-payment-button__button');

      paymentButtons.forEach(function (button) {
        if (variant && variant.available) {
          button.removeAttribute('disabled');
          button.classList.remove('disabled');
          button.setAttribute('aria-disabled', 'false');
        } else {
          button.setAttribute('disabled', 'disabled');
          button.classList.add('disabled');
          button.setAttribute('aria-disabled', 'true');
        }
      });
    }

    function updateHiddenVariantInput(variant) {
      if (!variantInput || !variant) return;

      variantInput.value = variant.id;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function updateUrl(variant) {
      if (!variant || !variant.id) return;
      if (!window.history || !window.history.replaceState) return;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);

      window.history.replaceState({}, '', url.toString());
    }

    function activateSlide(index) {
      if (!slides.length || !slides[index]) return;

      slides.forEach(function (slide) {
        slide.classList.remove('is-active');
      });

      slides[index].classList.add('is-active');
      currentSlideIndex = index;
    }

    function activateSlideByMediaId(mediaId) {
      if (!mediaId) return false;

      const targetIndex = slides.findIndex(function (slide) {
        return String(slide.dataset.mediaId) === String(mediaId);
      });

      if (targetIndex >= 0) {
        activateSlide(targetIndex);
        return true;
      }

      return false;
    }

    function getVariantMediaId(variant) {
      if (!variant) return null;

      return (
        variant.featured_media?.id ||
        variant.featured_image?.id ||
        null
      );
    }

    function getVariantImageSrc(variant) {
      if (!variant) return '';

      return (
        variant.featured_media?.preview_image?.src ||
        variant.featured_media?.src ||
        variant.featured_image?.src ||
        ''
      );
    }

    function activateSlideByImageSrc(imageSrc) {
      if (!imageSrc) return false;

      const normalizedVariantSrc = normalizeImageUrl(imageSrc);

      const targetIndex = slides.findIndex(function (slide) {
        const image = slide.querySelector('img');
        if (!image) return false;

        const imageSources = [
          image.currentSrc,
          image.src,
          image.getAttribute('src')
        ].map(normalizeImageUrl);

        return imageSources.some(function (src) {
          return src && normalizedVariantSrc && src.includes(normalizedVariantSrc);
        });
      });

      if (targetIndex >= 0) {
        activateSlide(targetIndex);
        return true;
      }

      return false;
    }

    function activateVariantImage(variant) {
      if (!variant) return false;

      if (activateSlideByMediaId(getVariantMediaId(variant))) {
        return true;
      }

      if (activateSlideByImageSrc(getVariantImageSrc(variant))) {
        return true;
      }

      return false;
    }

    function dispatchVariantChange(variant) {
      const event = new CustomEvent('bahari:variant-change', {
        bubbles: true,
        detail: {
          product: product,
          variant: variant
        }
      });

      section.dispatchEvent(event);

      if (productForm) {
        productForm.dispatchEvent(event);
      }
    }

    function updateVariant(changedInput) {
      const variant = findBestVariant(changedInput);

      if (!variant) return;

      syncInputsToVariant(variant);
      setSelectedClasses();
      updateHiddenVariantInput(variant);
      updatePrice(variant);
      updateUrl(variant);
      activateVariantImage(variant);
      updateSelectedTexts();
      updateOptionAvailability();
      setSelectedClasses();
      setButtonState(variant);
      dispatchVariantChange(variant);
    }

    function previewColorImage(input) {
      if (!input || !input.hasAttribute('data-option-color')) return;

      const colorIndex = getInputOptionIndex(input);

      const previewVariant =
        findFirstAvailableVariantForColor(colorIndex, input.value) ||
        findFirstVariantForColor(colorIndex, input.value);

      if (previewVariant) {
        activateVariantImage(previewVariant);
      }
    }

    function restoreSelectedVariantImage() {
      const selectedVariant = findVariantByOptions(getSelectedOptions());

      if (selectedVariant) {
        activateVariantImage(selectedVariant);
      }
    }

    function initOptions() {
      getOptionInputs().forEach(function (input) {
        input.addEventListener('change', function () {
          updateVariant(input);
        });
      });

      getColorInputs().forEach(function (input) {
        const label = section.querySelector('label[for="' + cssEscape(input.id) + '"]');

        input.addEventListener('mouseenter', function () {
          previewColorImage(input);
        });

        input.addEventListener('focus', function () {
          previewColorImage(input);
        });

        input.addEventListener('mouseleave', restoreSelectedVariantImage);
        input.addEventListener('blur', restoreSelectedVariantImage);

        if (label) {
          label.addEventListener('mouseenter', function () {
            previewColorImage(input);
          });

          label.addEventListener('focus', function () {
            previewColorImage(input);
          });

          label.addEventListener('mouseleave', restoreSelectedVariantImage);
          label.addEventListener('blur', restoreSelectedVariantImage);
        }
      });
    }

    function initGallery() {
      if (slides.length) {
        activateSlide(currentSlideIndex);
      }

      if (prevButton) {
        prevButton.addEventListener('click', function () {
          if (!slides.length) return;

          const nextIndex =
            currentSlideIndex <= 0
              ? slides.length - 1
              : currentSlideIndex - 1;

          activateSlide(nextIndex);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          if (!slides.length) return;

          const nextIndex =
            currentSlideIndex >= slides.length - 1
              ? 0
              : currentSlideIndex + 1;

          activateSlide(nextIndex);
        });
      }

      let touchStartX = 0;
      let touchEndX = 0;

      if (gallery) {
        gallery.addEventListener(
          'touchstart',
          function (event) {
            touchStartX = event.changedTouches[0].screenX;
          },
          { passive: true }
        );

        gallery.addEventListener(
          'touchend',
          function (event) {
            touchEndX = event.changedTouches[0].screenX;

            const difference = touchStartX - touchEndX;

            if (difference > 50 && nextButton) nextButton.click();
            if (difference < -50 && prevButton) prevButton.click();
          },
          { passive: true }
        );
      }
    }

    function initQuantity() {
      const quantityInput = section.querySelector('[data-quantity-input]');
      const minusButton = section.querySelector('[data-quantity-minus]');
      const plusButton = section.querySelector('[data-quantity-plus]');

      if (minusButton) {
        minusButton.addEventListener('click', function () {
          if (!quantityInput) return;

          const currentValue = Math.max(1, parseInt(quantityInput.value || '1', 10));
          quantityInput.value = String(Math.max(1, currentValue - 1));
          quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      if (plusButton) {
        plusButton.addEventListener('click', function () {
          if (!quantityInput) return;

          const currentValue = Math.max(1, parseInt(quantityInput.value || '1', 10));
          quantityInput.value = String(currentValue + 1);
          quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
    }

    function initInitialVariant() {
      let initialVariant = null;

      if (variantInput && variantInput.value) {
        initialVariant = product.variants.find(function (variant) {
          return String(variant.id) === String(variantInput.value);
        });
      }

      if (!initialVariant) {
        initialVariant = findVariantByOptions(getSelectedOptions());
      }

      if (!initialVariant) {
        initialVariant = findFirstAvailableVariant();
      }

      if (initialVariant) {
        syncInputsToVariant(initialVariant);
        updateHiddenVariantInput(initialVariant);
        updatePrice(initialVariant);
        activateVariantImage(initialVariant);
        updateSelectedTexts();
        updateOptionAvailability();
        setSelectedClasses();
        setButtonState(initialVariant);
      }
    }

    initGallery();
    initOptions();
    initQuantity();
    initInitialVariant();
  }

  function initAllBahariProducts(root) {
    const scope = root || document;

    scope.querySelectorAll('.bahari-product').forEach(function (section) {
      initBahariProduct(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllBahariProducts(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllBahariProducts(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    initAllBahariProducts(event.target);
  });
})();